// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27 transform=%27rotate%28180 12 12%29%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background: #000;
    color: #fff;
    height: 100vh;
    height: 100dvh;
    width: 100vw;
    overflow: hidden;
}

.app-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.visualizer-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

#visualizer {
    display: block;
    width: 100%;
    height: 100%;
}

.controls-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    pointer-events: none; /* Let clicks pass through to canvas if needed */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.controls-top {
    padding: 20px;
    background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
    pointer-events: auto;
    opacity: 0;
    transition: opacity 0.5s ease 5s;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.credits {
    font-size: 0.9em;
    color: rgba(255, 255, 255, 0.6);
}

.credits a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.2s;
}

.credits a:hover {
    color: #fff;
    text-decoration: underline;
}

.controls-bottom {
    padding: 20px;
    padding-bottom: max(20px, env(safe-area-inset-bottom));
    background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    pointer-events: auto;
    opacity: 0;
    transition: opacity 0.5s ease 5s;
}

/* Show controls on hover over the container */
.app-container:hover .controls-top,
.app-container:hover .controls-bottom {
    opacity: 1;
    transition: opacity 0.3s ease 0s;
}

.app-title {
    font-size: 1.5em;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.2s;
}

.app-title:hover {
    color: #fff;
    text-shadow: 0 0 15px rgba(0, 123, 255, 0.8);
}

.btn-icon {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(5px);
    font-size: 1em;
}

.btn-icon:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}

.icon-upload, .icon-play, .icon-stop, .icon-fullscreen, .icon-window {
    width: 22px;
    height: 22px;
}

.control-group {
    display: flex;
    align-items: center;
}

select {
    padding: 8px 30px 8px 15px;
    font-size: 14px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s, box-shadow 0.3s;
    backdrop-filter: blur(5px);
    outline: none;
    /* Ensure arrow has space */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
}

#presetSelect {
    width: clamp(300px, 42vw, 365px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

select:hover {
    background-color: rgba(0, 0, 0, 0.7);
    border-color: rgba(255, 255, 255, 0.4);
}

select:focus {
    border-color: #007bff;
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

select.menu-open {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.status-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 15px 30px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 30px;
    backdrop-filter: blur(10px);
    font-size: 1rem;
    pointer-events: none;
    z-index: 5;
    transition: opacity 0.5s ease;
    text-align: center;
}

/* Hide status when it's empty or after a timeout (handled by JS) */
.status-overlay.hidden {
    opacity: 0;
}

.btn-fullscreen {
    position: absolute;
    font-size: 1.2rem;
    bottom: 20px;
    bottom: max(20px, env(safe-area-inset-bottom));
    right: 20px;
    z-index: 20;
    opacity: 0;
    transition: opacity 0.5s ease 5s;
}

.app-container:hover .btn-fullscreen {
    opacity: 1;
    transition: opacity 0.3s ease 0s;
}

.fullscreen-hint {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9em;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 20;
    backdrop-filter: blur(5px);
}

.fullscreen-hint.visible {
    opacity: 1;
}

/* Tooltips */
[data-tooltip] {
    position: relative;
}

[data-tooltip]::before {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 6px 10px;
    background: rgba(0, 0, 0, 0.9);
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0.2s;
    pointer-events: none;
    z-index: 100;
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.5);
}

[data-tooltip]:hover::before {
    opacity: 1;
    visibility: visible;
}

/* Fix for absolute positioned elements */
.btn-fullscreen[data-tooltip] {
    position: absolute;
}

/* Position modifier for top elements */
[data-tooltip-pos="bottom"]::before {
    bottom: auto;
    top: 100%;
    margin-bottom: 0;
    margin-top: 8px;
}

/* Adjust tooltip for fullscreen button to not go off-screen if needed, 
   but centered above should be fine given margin */
@media (max-width: 768px) {
    .controls-bottom {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: left;
        gap: 10px;
    }
    
    .app-title {
        font-size: 1.2em;
    }
    
    #presetSelect, #colorScheme {
        max-width: calc(100vw - 360px);
    }
}

@media (max-width: 420px) {
    #presetSelect, #colorScheme {
        display: none !important;
    }

    #presetControl {
        display: none !important;
    }

    .controls-top {
        padding: 10px;
    }

    .app-title {
        font-size: 1em;
    }

    .credits {
        font-size: 0.75em;
    }
}
`, "",{"version":3,"sources":["webpack://./styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,4DAA4D;IAC5D,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oBAAoB,EAAE,gDAAgD;IACtE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8EAA8E;IAC9E,oBAAoB;IACpB,UAAU;IACV,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sDAAsD;IACtD,2EAA2E;IAC3E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,UAAU;IACV,gCAAgC;AACpC;;AAEA,8CAA8C;AAC9C;;IAEI,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,0CAA0C;IAC1C,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,qEAAqE;IACrE,0BAA0B;IAC1B,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,yDAAoR;IACpR,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,yDAAkT;AACtT;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,8CAA8C;IAC9C,WAAW;IACX,WAAW;IACX,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,UAAU;IACV,wBAAwB;IACxB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA,aAAa;AACb;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yCAAyC;IACzC,oBAAoB;IACpB,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;mDACmD;AACnD;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,qBAAqB;QACrB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background: #000;\n    color: #fff;\n    height: 100vh;\n    height: 100dvh;\n    width: 100vw;\n    overflow: hidden;\n}\n\n.app-container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.visualizer-wrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}\n\n#visualizer {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.controls-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    pointer-events: none; /* Let clicks pass through to canvas if needed */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.controls-top {\n    padding: 20px;\n    background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);\n    pointer-events: auto;\n    opacity: 0;\n    transition: opacity 0.5s ease 5s;\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n}\n\n.credits {\n    font-size: 0.9em;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.credits a {\n    color: rgba(255, 255, 255, 0.8);\n    text-decoration: none;\n    transition: color 0.2s;\n}\n\n.credits a:hover {\n    color: #fff;\n    text-decoration: underline;\n}\n\n.controls-bottom {\n    padding: 20px;\n    padding-bottom: max(20px, env(safe-area-inset-bottom));\n    background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    pointer-events: auto;\n    opacity: 0;\n    transition: opacity 0.5s ease 5s;\n}\n\n/* Show controls on hover over the container */\n.app-container:hover .controls-top,\n.app-container:hover .controls-bottom {\n    opacity: 1;\n    transition: opacity 0.3s ease 0s;\n}\n\n.app-title {\n    font-size: 1.5em;\n    font-weight: bold;\n    text-shadow: 0 0 10px rgba(0, 123, 255, 0.5);\n    color: rgba(255, 255, 255, 0.8);\n    text-decoration: none;\n    transition: color 0.2s;\n}\n\n.app-title:hover {\n    color: #fff;\n    text-shadow: 0 0 15px rgba(0, 123, 255, 0.8);\n}\n\n.btn-icon {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    backdrop-filter: blur(5px);\n    font-size: 1em;\n}\n\n.btn-icon:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: scale(1.1);\n    box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);\n}\n\n.icon-upload, .icon-play, .icon-stop, .icon-fullscreen, .icon-window {\n    width: 22px;\n    height: 22px;\n}\n\n.control-group {\n    display: flex;\n    align-items: center;\n}\n\nselect {\n    padding: 8px 30px 8px 15px;\n    font-size: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 20px;\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.3s, border-color 0.3s, box-shadow 0.3s;\n    backdrop-filter: blur(5px);\n    outline: none;\n    /* Ensure arrow has space */\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 16px;\n}\n\n#presetSelect {\n    width: clamp(300px, 42vw, 365px);\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\nselect:hover {\n    background-color: rgba(0, 0, 0, 0.7);\n    border-color: rgba(255, 255, 255, 0.4);\n}\n\nselect:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);\n}\n\nselect.menu-open {\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9' transform='rotate(180 12 12)'%3e%3c/polyline%3e%3c/svg%3e\");\n}\n\n.status-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: 15px 30px;\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 30px;\n    backdrop-filter: blur(10px);\n    font-size: 1rem;\n    pointer-events: none;\n    z-index: 5;\n    transition: opacity 0.5s ease;\n    text-align: center;\n}\n\n/* Hide status when it's empty or after a timeout (handled by JS) */\n.status-overlay.hidden {\n    opacity: 0;\n}\n\n.btn-fullscreen {\n    position: absolute;\n    font-size: 1.2rem;\n    bottom: 20px;\n    bottom: max(20px, env(safe-area-inset-bottom));\n    right: 20px;\n    z-index: 20;\n    opacity: 0;\n    transition: opacity 0.5s ease 5s;\n}\n\n.app-container:hover .btn-fullscreen {\n    opacity: 1;\n    transition: opacity 0.3s ease 0s;\n}\n\n.fullscreen-hint {\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(0, 0, 0, 0.6);\n    padding: 8px 16px;\n    border-radius: 20px;\n    font-size: 0.9em;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.3s;\n    z-index: 20;\n    backdrop-filter: blur(5px);\n}\n\n.fullscreen-hint.visible {\n    opacity: 1;\n}\n\n/* Tooltips */\n[data-tooltip] {\n    position: relative;\n}\n\n[data-tooltip]::before {\n    content: attr(data-tooltip);\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 6px 10px;\n    background: rgba(0, 0, 0, 0.9);\n    color: #fff;\n    font-size: 12px;\n    border-radius: 4px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.2s, visibility 0.2s;\n    pointer-events: none;\n    z-index: 100;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    margin-bottom: 8px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.5);\n}\n\n[data-tooltip]:hover::before {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* Fix for absolute positioned elements */\n.btn-fullscreen[data-tooltip] {\n    position: absolute;\n}\n\n/* Position modifier for top elements */\n[data-tooltip-pos=\"bottom\"]::before {\n    bottom: auto;\n    top: 100%;\n    margin-bottom: 0;\n    margin-top: 8px;\n}\n\n/* Adjust tooltip for fullscreen button to not go off-screen if needed, \n   but centered above should be fine given margin */\n@media (max-width: 768px) {\n    .controls-bottom {\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: left;\n        gap: 10px;\n    }\n    \n    .app-title {\n        font-size: 1.2em;\n    }\n    \n    #presetSelect, #colorScheme {\n        max-width: calc(100vw - 360px);\n    }\n}\n\n@media (max-width: 420px) {\n    #presetSelect, #colorScheme {\n        display: none !important;\n    }\n\n    #presetControl {\n        display: none !important;\n    }\n\n    .controls-top {\n        padding: 10px;\n    }\n\n    .app-title {\n        font-size: 1em;\n    }\n\n    .credits {\n        font-size: 0.75em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
